import { Link, Typography } from '@montugroup/design-system';

import settings from '@/constants/constants';
import { ActionText, Faq, FaqButton, FaqButtonContainer, FaqContainer } from './OrderHistoryCard.styles';

const umedsFAQButtons = [
  {
    link: `${settings.support.site.url}/articles/10724840280847-Delivery-process`,
    text: 'Track my order',
  },
  {
    link: settings.support.site.url,
    text: 'Get further assistance',
  },
];

const shippingFAQButtons = [
  {
    link: `${settings.support.site.url}/articles/10724840280847-Delivery-process`,
    text: 'Delivery timeframes',
  },
  ...umedsFAQButtons,
];

const clickAndCollectFAQButtons = [
  {
    link: `${settings.support.site.url}/articles/15139942467855-Click-Collect-Process`,
    text: 'Click & collect process',
  },
  ...umedsFAQButtons,
];

export function FAQButtons({ isClickAndCollect }: { isClickAndCollect: boolean }) {
  const buttons = isClickAndCollect ? clickAndCollectFAQButtons : shippingFAQButtons;
  return (
    <FaqContainer>
      <Faq>
        <Typography variant="subtitle1" fontWeight="semibold" sx={(theme) => ({ marginBottom: theme.spacing(6) })}>
          Need help?
        </Typography>
        <FaqButtonContainer>
          {buttons.map((button, i) => (
            <Link key={i} href={button.link} target="_blank">
              <FaqButton variant="outlined" fullWidth>
                <ActionText variant="body1">{button.text}</ActionText>
              </FaqButton>
            </Link>
          ))}
        </FaqButtonContainer>
      </Faq>
    </FaqContainer>
  );
}

export default FAQButtons;
